// 统一配置入口文件
export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/api/"
    : "http://192.168.31.103:9093/mathub/v8/";
